var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "upload-file"
  }, [_vm.row ? _c('b-modal', {
    attrs: {
      "id": "repRequestfailed",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "repRejectModal-header text-center"
        }, [_c('h4', [_vm._v("Approval Request")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }], null, false, 3451724542)
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "repRejectModal-form text-center"
  }, [_c('div', {}, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/fail.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("Approving "), _c('span', {
    staticClass: "failed"
  }, [_vm._v("Request Failed !!")])]), _c('div', {
    staticClass: "mb-2"
  }, [_vm._v("Approving Request Failed might be network issue occurred while processing your payment")]), _c('div', {
    staticClass: "try-again"
  }, [_vm._v("Try Again")])])])], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }